import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Testimonial {
  id: number;
  name: string;
  location: string;
  avatar: string;
  alt: string;
  rating: number;
  quote: string;
  result: string;
}

const TestimonialSection = () => {
  const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Sarah Chen",
    location: "San Francisco, CA",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19dc77a7e-1762274545448.png",
    alt: "Professional Asian woman with shoulder-length black hair smiling warmly in modern office setting",
    rating: 5,
    quote: "Transformed my 6x8 balcony into a thriving herb garden. The AI recommendations were spot-on and I'm now earning $150/month selling fresh herbs to local restaurants.",
    result: "$150/month income"
  },
  {
    id: 2,
    name: "Marcus Rodriguez",
    location: "Austin, TX",
    avatar: "https://images.unsplash.com/photo-1621267527469-dc8dbcc48f0b",
    alt: "Hispanic man with beard and friendly smile wearing casual blue shirt outdoors",
    rating: 5,
    quote: "The space measurement tools helped me maximize every inch of my small backyard. Now I grow enough vegetables to feed my family and have surplus to sell at the farmer's market.",
    result: "90% space efficiency"
  },
  {
    id: 3,
    name: "Emily Johnson",
    location: "Brooklyn, NY",
    avatar: "https://images.unsplash.com/photo-1717454396563-a8e605c98a86",
    alt: "Young Caucasian woman with blonde hair and bright smile in casual white top",
    rating: 5,
    quote: "As a complete beginner, the seasonal planning feature was a game-changer. My rooftop garden now produces year-round, and I've learned so much about sustainable living.",
    result: "Year-round production"
  }];


  return (
    <section className="py-16 lg:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground">
            Success Stories from
            <span className="text-primary block">Real Users</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Join thousands of users who have transformed their small spaces into productive, income-generating areas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) =>
          <div
            key={testimonial.id}
            className="bg-card border border-border rounded-xl p-6 space-y-6 hover:shadow-lg transition-shadow duration-300">

              {/* Rating */}
              <div className="flex items-center space-x-1">
                {[...Array(testimonial.rating)].map((_, i) =>
              <Icon key={i} name="StarIcon" size={16} className="text-accent fill-current" />
              )}
              </div>

              {/* Quote */}
              <blockquote className="text-foreground leading-relaxed">
                "{testimonial.quote}"
              </blockquote>

              {/* Result Badge */}
              <div className="inline-flex items-center px-3 py-1 bg-success/10 text-success text-sm font-medium rounded-full">
                <Icon name="TrophyIcon" size={14} className="mr-1" />
                {testimonial.result}
              </div>

              {/* Author */}
              <div className="flex items-center space-x-3 pt-4 border-t border-border">
                <AppImage
                src={testimonial.avatar}
                alt={testimonial.alt}
                className="w-12 h-12 rounded-full object-cover" />

                <div>
                  <div className="font-semibold text-foreground">{testimonial.name}</div>
                  <div className="text-sm text-muted-foreground">{testimonial.location}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default TestimonialSection;